module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-field', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Your email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "password-reveal": "",
      "placeholder": "Your password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('b-checkbox', [_vm._v("Remember me")])], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$parent.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_vm._v("Login")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Login")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b08a4990","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalForm.vue
// module id = 521
// module chunks = 1